import React, { useEffect, useState } from "react";
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import Label from "@mui/icons-material/Label";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import StyledTreeItem from "../StyledTree/StyledTreeItem";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import LoaderComponent from "../Loader/LoaderComponent";
import "./MenuListComponent.css";
import { MILLER_UI_TEXT } from "../../textConstant";
import useTranslatewrapper from "../useTranslateWrapper";

export default function MenuListComponentNew({ menuDetails }) {
  const {translate} = useTranslatewrapper();
  const filterDataRedux = useSelector((state) => state.filterData);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // kajsdkdjffhj

  const capitalize = (str) => {
    return str?.charAt(0).toUpperCase() + str?.slice(1);
  };
  const [idList, setIdList] = useState([]);
  const [loader, setLoader] = React.useState(true);

  useEffect(() => {
    if (menuDetails?.length > 0) {
      const arrayOfNodeIds = Array.from(
        Array(Number(menuDetails[menuDetails.length - 1].nodeId)).keys()
      );
      setIdList(() => arrayOfNodeIds.map((item) => JSON.stringify(item + 1)));
      setLoader(false);
    }
  }, []);

  const setFilters = (id, categoryId) => {

    // if (id.length > 1) id = [];
    if (id.length == 0) id = [];
    const json = filterDataRedux.searchCriteriaList;
    const json1 = structuredClone(json);
    json1[3].value = [id];
    json1[4].value = String(categoryId);
    dispatch({
      type: "UPDATE_FILTER",
      data: json1,
    });
  };

  const generateRouteComponent = (routeDetail) => {
    // const parent = menuDetails.find(item => item.entityStates[0].categoryId === routeDetail.categoryId)
    if (routeDetail?.categoryName) {
      navigate(
        `/${routeDetail?.categoryName.toLowerCase().split(" ").join("-")}/${
          routeDetail?.categoryId
        }`
      );
    } else if (routeDetail?.name && routeDetail?.nodeId) {
      const categoryName = menuDetails.find(
        (elem) => elem.categoryId === routeDetail.categoryId
      )?.categoryName;
      navigate(
        `/${categoryName.toLowerCase().split(" ").join("-")}/${
          routeDetail?.categoryId
        }`
      );
    }
  };

  return (
    <>
      {loader || !menuDetails?.length || !idList?.length ? (
        <LoaderComponent />
      ) : (
        <>
          {idList?.length > 0 && (
            <TreeView
              defaultEndIcon={<div style={{ width: 24 }} />}
              sx={{
                height: 264,
                flexGrow: 1,
                maxWidth: 400,
                overflowY: "auto",
              }}
              expanded={idList}
            >
              {menuDetails &&
                menuDetails.length > 0 &&
                menuDetails.map((menuDetail) => (
                  <TreeItem
                    id="heading1"
                    key={menuDetail.nodeId}
                    nodeId={menuDetail?.nodeId}
                    label={translate(capitalize(menuDetail?.categoryName.toUpperCase().replace('MILLER',MILLER_UI_TEXT)))}
                    onClick={() => {
                      generateRouteComponent(menuDetail);
                      if (menuDetail?.entityStates) {
                        setFilters("all", menuDetail?.categoryId);

                      }

                     
                    }}
                  >
                    {menuDetail?.entityStates &&
                      menuDetail.entityStates.length > 0 &&
                      menuDetail?.entityStates?.map((states) => (
                        <StyledTreeItem
                          key={states.nodeId}
                          nodeId={states.nodeId}
                          labelText={
                            capitalize(translate(states?.displayName?.toLowerCase())) || ""
                          }
                          labelIcon={SupervisorAccountIcon}
                          iconName={
                            states?.displayName?.toLowerCase() === "all"
                              ? menuDetail?.categoryName?.toLowerCase()
                              : states?.displayName?.toLowerCase()
                          }
                          onClick={() => {
                            
                            setFilters(states?.name, states?.categoryId);
                            generateRouteComponent(states);
                          }}
                        ></StyledTreeItem>
                      ))}
                  </TreeItem>
                ))}
            </TreeView>
          )}
        </>
      )}
    </>
  );
}
